"use strict";

function format_money(x) {
    x /= 100;
    return '$' + (x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")/*.replace('.00', '')*/);
}

function handleize(str) {
    return str.toLowerCase().replace("'", '').replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
}

function lazyloadImageSrcset(src) {
    let widths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

    src = src.split('?');
    src = src[0].replace(/\.(jpg|png|jpeg|gif)/, '_{width}x.$1');

    let _image_srcset = [];
    for(let i = 0; i < widths.length; i++) {
        _image_srcset.push(src.replace('_{width}x.', '_'+widths[i]+'x.')+' '+widths[i]+'w');
    }

    return _image_srcset;
}

function get_image(src, sizes = '100vw', lazy = false) {
    let img = '<img';
    img += ' src="' + src + '"';
    img += ' srcset="' + lazyloadImageSrcset(src) + '"';
    if(sizes) img += ' sizes="' + sizes + '"';
    if(lazy) img += ' loading="lazy"';
    img += '>';

    return img;
}

// let qty_buttons = document.querySelectorAll('.product__quantity-button');
// for(let i = 0; i < qty_buttons.length; i++) qty_buttons[i].addEventListener('click', (e) => {
//     e.preventDefault();
//     const parent = e.target.closest('.product__quantity');
//     if(!parent)
//         return;

//     const valueEl = parent.querySelector('.product__quantity-value');
//     if(!valueEl)
//         return;

//     let value = valueEl.value;

//     if(e.target.classList.contains('product__quantity-button--less')) value--;
//     else value++;

//     if(value < 1) value = 1;

//     valueEl.value = value;
// });

const color_swatches = document.querySelectorAll('.color-swatch');
for(let i = 0; i < color_swatches.length; i++) {
    color_swatches[i].addEventListener('click', function(e) {
        e.preventDefault();
        const cont = this.parentNode;

        if(cont.classList.contains('color-swatches--groups')) {
            this.classList.toggle('color-swatch--active');
        } else {
            const active = cont.querySelectorAll('.color-swatch--active');
        
            const title = this.getAttribute('title');
            let prod_option = this.closest('.product-option__container');
            if(prod_option) {
                let titleCont = prod_option.querySelector('.product-option__value');
                if(titleCont) titleCont.innerHTML = title;
            }
    
            for(let j = 0; j < active.length; j++) active[j].classList.remove('color-swatch--active');

            this.classList.add('color-swatch--active');

            let value = this.getAttribute('data-value');
    
            let unit = this.closest('.product-unit');
            if(unit) {
                let optionNum = cont.getAttribute('data-option');
                let selector = unit.querySelector('.variant-select');
                let availableOption = selector.querySelector('option[data-available="true"][data-option' + optionNum + '="' + value + '"]');
                if(!availableOption) availableOption = selector.querySelector('option[data-option' + optionNum + '="' + value + '"]');
    
                if(availableOption) {
                    selector.value = availableOption.value;
    
                    let event = new Event('change');
                    selector.dispatchEvent(event);
                }
            }
    
            let pdp = this.closest('.pdp__main');
            if(pdp) {
                updateProductOptions(pdp);
                updateProductSelect(pdp);
            }
        }
    });
}

let url_vars = ''; 
if(document.location.href.indexOf('?') > -1) {
    url_vars = document.location.href.split('?');
    if(url_vars.length > 1) url_vars = '?' + url_vars[1];
    else url_vars = '';
}

const variantSelects = document.querySelectorAll('.variant-select');
const variantSelectUpdate = function (recivedSelector) {
    let selector = this || recivedSelector;
    let option = selector.options[selector.selectedIndex];
    let option1_selected_radio = $(option).attr("data-option1");
    //console.log($(option).attr("data-option1"))
    //console.log($(`[data-color-variant="${option1_selected_radio}"]`))
    
    if($(`[data-color-variant="${option1_selected_radio}"]`).toArray().length > 0) {
        $(`[data-color-variant="${option1_selected_radio}"]`).click()
    }
    let unit = selector.closest('.product-unit');
    //console.log(unit)
    if(unit) {
        if(option.hasAttribute('data-image')) {
            let image = option.getAttribute('data-image');
            if(image) {
                let imageEl = unit.querySelector('.product-unit__image img');
                if(imageEl) imageEl.setAttribute('srcset', lazyloadImageSrcset(image));
            }
        }

        let price = option.getAttribute('data-price');
        let priceEl = unit.querySelector('.product-unit__price');
        if(priceEl) priceEl.innerHTML = price;

        let urlOption = option.getAttribute('data-option1');
        if(option.hasAttribute('data-option2')) urlOption += '_' + option.getAttribute('data-option2');

        let url = '/products/' + selector.getAttribute('data-handle') + '/' + urlOption;

        let links = unit.querySelectorAll('.product-unit__link');
        for(let i = 0; i < links.length; i++) links[i].setAttribute('href', url);

        let available = option.getAttribute('data-available') == 'true';
        if(available) unit.classList.remove('product-unit--unavailable');
        else unit.classList.add('product-unit--unavailable');
    }

    let pdp = selector.closest('.pdp__main');
    if(pdp) {

        const product_handle = selector.getAttribute('data-handle');
        let attr = option.getAttribute('data-option1');
        
        if(option.hasAttribute('data-option2')) attr += '_' + option.getAttribute('data-option2');
        const expected = pdp.querySelector('.product__expected');
        const add_button = pdp.querySelector('.product__buttons .add-button');
        const available = option.getAttribute('data-available');
        const incoming = option.getAttribute('data-incoming-date');

        if(document.location.href.indexOf('?preview_key=') === -1) window.history.replaceState({}, '', '/products/' + product_handle + '/' + attr + url_vars );
    
        expected.classList.remove('product__expected--active');
    
        if(incoming) {
            add_button.setAttribute('data-status', 'preorder');
            expected.classList.add('product__expected--active');
            expected.innerHTML = incoming;
        } else if(available == 'false') {
            add_button.setAttribute('data-status', 'unavailable');
        } else {
            add_button.setAttribute('data-status', 'default');
        }
    
        let event = new CustomEvent("variant-change", { bubbles: true, detail: attr });
        document.dispatchEvent(event);
    }
};
for(let i = 0; i < variantSelects.length; i++) variantSelects[i].addEventListener('change', variantSelectUpdate);
let pdp = document.querySelector('.pdp__main');
if(pdp) {
    updateProductOptions(pdp);
    updateProductSelect(pdp);
}

const prod_options = document.querySelectorAll('select.product-option');
for(let i = 0; i < prod_options.length; i++) prod_options[i].addEventListener('change', function(e) {
    changeProductOption(this);
    
    let pdp = this.closest('.pdp__main');
    if(pdp) updateProductSelect(pdp);
});

function changeProductOption(select) {
    const title = select.options[select.selectedIndex].getAttribute('data-title');
    let prod_option = select.closest('.product-option__container');
    if(prod_option) {
        let titleCont = prod_option.querySelector('.product-option__value');
        if(titleCont) titleCont.innerHTML = title;
    }
}

function updateProductOptions(pdp) {
    return;
    let option1 = pdp.querySelector('[data-option="1"]');
    let option2 = pdp.querySelector('[data-option="2"]');

    const prod_select = pdp.querySelector('.variant-select');

    if(option1 && option2) {
        let option_value;
        if(option1.classList.contains('color-swatches')) option_value = option1.querySelector('.color-swatch--active').getAttribute('data-value');
        else option_value = option1.value;

        let options = prod_select.querySelectorAll('option[data-option1="' + option_value + '"]');
        
        let option2List = [];
        // let option3List = [];
        for(let i = 0; i < options.length; i++) {
            if(option2) option2List.push(options[i].getAttribute('data-option2'));
            // if(option3) option3List.push(options[i].getAttribute('data-option3'));
        }

        if(option2) {
            let option2Selected = option2.selectedIndex;
            let hiddenCount = 0;
            for(let i = 0; i < option2.options.length; i++) {
                if(option2List.indexOf(option2.options[i].value) > -1) {
                    option2.options[i].hidden = false;
                    option2.options[i].disabled = false;
                } else {
                    hiddenCount++;
                    option2.options[i].hidden = true;
                    option2.options[i].disabled = true;

                    if(option2Selected == i) changeProductOption(option2);
                }
            }

            if(hiddenCount >= option2.options.length - 1) option2.closest('.product-option__container').classList.add('product-option__container--single-option');
            else option2.closest('.product-option__container').classList.remove('product-option__container--single-option');
        }
    }
}

function updateProductSelect(pdp) {
    let option1 = pdp.querySelector('[data-option="1"]');
    let option2 = pdp.querySelector('[data-option="2"]');
    let option3 = pdp.querySelector('[data-option="3"]');

    const prod_select = pdp.querySelector('.variant-select');
    let selector = [];

    if(option1) {
        let option_value;
        if(option1.classList.contains('color-swatches')) option_value = option1.querySelector('.color-swatch--active').getAttribute('data-value');
        else if(option1.value != '') option_value = option1.value;
        else option_value = option1.querySelector('[data-selected]').value;
        selector.push('[data-option1="' + option_value + '"]');
    }

    if(option2) {
        let option_value;
        if(option2.classList.contains('color-swatches')) option_value = option2.querySelector('.color-swatch--active').getAttribute('data-value');
        else if(option2.value != '') option_value = option2.value;
        else option_value = option2.querySelector('[data-selected]').value;
        selector.push('[data-option2="' + option_value + '"]');
    }

    if(option3) {
        let option_value;
        if(option3.classList.contains('color-swatches')) option_value = option3.querySelector('.color-swatch--active').getAttribute('data-value');
        else if(option3.value != '') option_value = option3.value;
        else option_value = option3.querySelector('[data-selected]').value;
        selector.push('[data-option3="' + option_value + '"]');
    }

    let option = prod_select.querySelector('option' + selector.join(''));
    if(!option) {
        option = prod_select.querySelector('option' + selector[0]);
        let select = pdp.querySelector('.product-option[data-option="2"]');
        if(select) {
            select.selectedIndex = 0;
            changeProductOption(select);
        }
    }
console.log(prod_select.value);
console.log(option.value);
    if(option) {
        prod_select.value = option.value;
        let media = document.querySelector('.pdp__media');
        if(media) {
            let opt1 = option.getAttribute('data-option1');
            let opt2 = option.getAttribute('data-option2');
            
            let allThumbs = pdp.querySelectorAll('.pdp__media-thumb');
            for(let i = 0; i < allThumbs.length; i++) allThumbs[i].classList.remove('pdp__media-thumb--shown');

            let activeThumbs = pdp.querySelectorAll('.pdp__media-thumb[data-variant=""],.pdp__media-thumb[data-variant~="' + opt1 + '"],.pdp__media-thumb[data-variant~="' + opt2 + '"]');
            for(let i = 0; i < activeThumbs.length; i++) activeThumbs[i].classList.add('pdp__media-thumb--shown');

            let allImgs = pdp.querySelectorAll('.pdp__image');
            for(let i = 0; i < allImgs.length; i++) allImgs[i].classList.remove('pdp__image--shown');

            let activeImgs = pdp.querySelectorAll('.pdp__image[data-variant=""],.pdp__image[data-variant~="' + opt1 + '"],.pdp__image[data-variant~="' + opt2 + '"]');
            for(let i = 0; i < activeImgs.length; i++) activeImgs[i].classList.add('pdp__image--shown');

            let mediaContent = document.querySelector('.pdp__media-content');
            mediaContent.scrollLeft = 0;
        }

        if(!Shopify.designMode) {
            let event = new Event('change');
            prod_select.dispatchEvent(event);
        }
    }
}

let thumbs = document.querySelectorAll('.pdp__media-thumb');
if(thumbs.length > 0) for(let i = 0; i < thumbs.length; i++) thumbs[i].addEventListener('click', function(e) {
    e.preventDefault();
    let cont = this.closest('.pdp__media');
    if(!cont) return;
    let activeThumbs = cont.querySelectorAll('.pdp__media-thumb--shown');
    let index = 0;
    for(let i = 0; i < activeThumbs.length; i++) if(activeThumbs[i] == this) {
        index = i;
        break;
    }

    let slider = cont.querySelector('.pdp__media-content');

    slider.scrollLeft = index * slider.offsetWidth;
});

function removeProduct(keys, callback) {
    let updates = {};
    for(let i = 0; i < keys.length; i++) updates[keys[i]] = 0;

    fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            updates: updates
        })
    })
    .then(response => response.json())
    .then(response => {
        if(typeof callback == 'function') callback(response);
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

////////////////////////////////////// Filters //////////////////////////////////////////
let items = document.querySelectorAll('.product-unit');
let vendors = {};
let vendorsMD5Map = {};
for(let i = 0; i < items.length; i++) {
    let vendor = items[i].querySelector('.product-unit__vendor').innerHTML;
    let vendorHandle = handleize(vendor);

    let vendormd5 = items[i].querySelector('.product-unit__vendor').getAttribute('md5val');
    //console.log("vendormd5" + vendormd5);
  
    if(typeof vendors[vendorHandle] == 'undefined') vendors[vendorHandle] = vendor;
    if(typeof vendorsMD5Map[vendorHandle] == 'undefined') vendorsMD5Map[vendorHandle] = vendormd5;
  

    let swatches = items[i].querySelectorAll('.color-swatch');
    let selector = [];
    for(let j = 0; j < swatches.length; j++) {
        selector.push('.product-filter--color [data-colors~=' + swatches[j].getAttribute('data-value') + ']');
    }
    if(selector.length > 0) {
        let activateSwatches = document.querySelectorAll(selector.join(','));
        for(let j = 0; j < activateSwatches.length; j++) activateSwatches[j].classList.add('color-swatch--shown');
    }
}

//VENDORS
let designerFilter = document.querySelector('.product-filter--designer .product-filter__values');
if(designerFilter) {
  /*
    for (let key in vendors) {
        //console.log("KEY" + key);
        let newEl = document.createElement('li');

        let innerMD5Key = vendorsMD5Map[key]; 
        newEl.innerHTML = '<input type="checkbox" id="designer-' + key + '" value="'+innerMD5Key+'" NOvalue="' + key + '"><label for="designer-' + key + '">' + vendors[key] + '</label>';

        designerFilter.appendChild(newEl);
    }
  */
}


if(designerFilter) {
    // Create an array of entries [key, value] from the vendors object
    let vendorsArray = Object.entries(vendors).map(([key, value]) => ({
        key: key,
        value: value,
        md5: vendorsMD5Map[key]
    }));
    
    // Sort the array alphabetically by vendor name (value)
    vendorsArray.sort((a, b) => a.value.localeCompare(b.value));
    
    // Append the sorted vendors to the filter
    vendorsArray.forEach(vendor => {
        let newEl = document.createElement('li');
        newEl.innerHTML = '<input type="checkbox" id="designer-' + vendor.key + 
                          '" value="' + vendor.md5 + 
                          '" NOvalue="' + vendor.key + 
                          '"><label for="designer-' + vendor.key + 
                          '">' + vendor.value + '</label>';
        designerFilter.appendChild(newEl);
    });
}


//Size Filter
//let sizeFilter = document.querySelector('.product-filter--size .product-filter__values');


// Custom sort function for sizes
function sortSizes(sizeMapper) {
  // Define standard sizes and their order
  const standardSizes = { "XS" : 1, "S": 2, "M": 3, "L": 4, "XL": 5 , "S M":6 , "M L" : 7 , "L XL" : 8, "OS" : 9, "ZZ" : 10};
  
  // Convert to array of [key, value] pairs for sorting
  return Object.keys(sizeMapper).sort((a, b) => {
    // Skip empty sizes
    if (a === '') return 1;
    if (b === '') return -1;
    
    // Handle standard sizes (S, M, L, XL)
    const aIsStandard = a in standardSizes;
    const bIsStandard = b in standardSizes;
    
    if (aIsStandard && bIsStandard) {
      return standardSizes[a] - standardSizes[b];
    }
    if (aIsStandard) return -1;
    if (bIsStandard) return 1;
    
    // Handle numeric sizes
    const aIsNumeric = !isNaN(parseFloat(a)) && isFinite(a);
    const bIsNumeric = !isNaN(parseFloat(a)) && isFinite(b);
    
    if (aIsNumeric && bIsNumeric) {
      return parseFloat(a) - parseFloat(b);
    }
    if (aIsNumeric) return -1;
    if (bIsNumeric) return 1;
    
    // Everything else alphabetically
    return a.localeCompare(b);
  });
}


// Get sorted size keys





let sizeFilter1 = document.querySelector('.sizecol1');
let sizeFilter2 = document.querySelector('.sizecol2');
let sizeFilter3 = document.querySelector('.sizecol3');

if(sizeFilter1) {
  let totSizeItems = 0;
  for (const sizekey in sizeMapper){
      if(sizekey != '')
        totSizeItems++;
  }
  
  let thirdCol = Math.ceil(totSizeItems/3);
  let thirdColNext = thirdCol*2;
  let ctr=0;

  let sortedSizeKeys = sortSizes(sizeMapper);
  //for (const sizekey in sortedSizeKeys){
  sortedSizeKeys.forEach(sizekey => {
      
        //console.log(`Key: ${sizekey}, Value: ${sizeMapper[sizekey]}`);
        //$('.ZZproduct-filter__values').append('<li><input value="xs" type="checkbox" id="filter-size-xs"><label for="filter-size-xs">'+sizekey+'</label></li>');
        //console.log(sizekey + " thirdCol " + thirdCol + " thirdColNext " + thirdColNext + " ctr " + ctr);

        if(sizekey != ''){
    
          if(ctr<thirdCol){
            let newEl = document.createElement('li');
            newEl.innerHTML = '<input type="checkbox" id="size-' + sizekey + 
                          '" value="' + sizekey + 
                          '"><label style="text-wrap:nowrap" for="size-' + sizekey + 
                          '">' + sizekey + '</label>';
            sizeFilter1.appendChild(newEl);
           }else  if(ctr<thirdColNext){
            let newEl = document.createElement('li');
            newEl.innerHTML = '<input type="checkbox" id="size-' + sizekey + 
                          '" value="' + sizekey + 
                          '"><label style="text-wrap:nowrap" for="size-' + sizekey + 
                          '">' + sizekey + '</label>';
            sizeFilter2.appendChild(newEl);
                 
          }else{
            let newEl = document.createElement('li');
            newEl.innerHTML = '<input type="checkbox" id="size-' + sizekey + 
                          '" value="' + sizekey + 
                          '"><label style="text-wrap:nowrap" for="size-' + sizekey + 
                          '">' + sizekey + '</label>';
            sizeFilter3.appendChild(newEl);
          
          }

        ctr++;

        } //sizekey != ''

  });  //loop
  
} //if

/*
let allSizes = document.querySelectorAll('.product-filter--size input');
for(let i = 0; i < allSizes.length; i++) {
    let value = allSizes[i].value;
    if(!document.querySelector('.product-unit .variant-select option[data-option1="' + value + '"], .product-unit .variant-select option[data-option2="' + value + '"]')) allSizes[i].parentNode.classList.add('filter-disabled');
}
*/


if(document.querySelector('.product-filter--color')) {
    let activeColorSwatches = document.querySelector('.product-filter--color .color-swatch--shown');
    if(!activeColorSwatches) document.querySelector('.product-filter--color').remove();
}

function applyFilters() {
    console.log("applyFilters()");
    console.log("*** items.length:" + items.length);
  
    const sort_check = document.querySelector('input[name="filter-sort"]:checked');
    if(sort_check) 
         document.querySelector('.products-grid').setAttribute('data-sort', sort_check.value);
    else 
         document.querySelector('.products-grid').removeAttribute('data-sort');

    //console.log("sort_check:" + sort_check.value);
  
    const vendor_check = document.querySelectorAll('.product-filter--designer input:checked');
    const color_check = document.querySelectorAll('.product-filter--color .color-swatch--active');
    const size_check = document.querySelectorAll('.product-filter--size input:checked');

  
    for(let i = 0; i < items.length; i++) {
        items[i].classList.remove('product-unit--filtered-out');
    }

  
    for(let i = 0; i < items.length; i++) {
        let item = items[i];

        if(vendor_check.length) {
            let matchFound = false;
            let vendor = '';
            for(let j = 0; j < vendor_check.length; j++) {
                vendor = vendor_check[j].value;
                console.log("***vendor:" + vendor);
                if(item.querySelector('.product-unit__vendor[data-value="' + vendor + '"]')) {
                    matchFound = true;
                    break;
                }
                //Add DS 2-15-2025
                let vendor_alias = vendor.replace("-amp-", "-");
                if(item.querySelector('.product-unit__vendor[data-value="' + vendor_alias + '"]')) {
                    matchFound = true;
                    break;
                }
            }

            if(!matchFound){
              //console.log("hide vendor:" + vendor);
              item.classList.add('product-unit--filtered-out');
            }else{
              //console.log("show vendor:" + vendor);
              
            }
        }
        
      
      if(size_check.length) {

            let matchFound = false;
            for(let j = 0; j < size_check.length; j++) {
                let size = size_check[j].value;

                //console.log("SIZE CHECK LOGIC");

                let checkSizeItem =  item.querySelector('.product-unit__sizes');

                //console.log("SIZE CHECK ITEM size=" + size + " Classes:" + checkSizeItem.classList);
                //if(item.querySelector('.product-unit .variant-select option[data-option1="' + size + '"][data-available="true"], .product-unit .variant-select option[data-option2="' + size + '"][data-available="true"]')) {
                if(item.querySelector('.product-unit__sizes.size_' + size)) {
                    matchFound = true;
                    break;
                }
            }

            if(!matchFound) item.classList.add('product-unit--filtered-out');
        }
    }

    let hiddenItems = document.querySelectorAll('.product-unit--filtered-out');
    let nothing = document.querySelector('.product-grid__nothing-found');

    if(hiddenItems.length == items.length) nothing.classList.add('product-grid__nothing-found--active');
    else nothing.classList.remove('product-grid__nothing-found--active');

  console.log("END applyFilters()");
}

let filterActivators = document.querySelectorAll('.product-filter input[type="radio"], .product-filter input[type="checkbox"],.product-filter .color-swatch');
for(let i = 0; i < filterActivators.length; i++) filterActivators[i].addEventListener('click', applyFilters);

let resetFilter = document.querySelector('.reset-filter');
if(resetFilter) resetFilter.addEventListener('click', function(e) {
    e.preventDefault();
    let activeFilterInputs = document.querySelectorAll('.product-filter input:checked');
    for(let i = 0; i < activeFilterInputs.length; i++) activeFilterInputs[i].checked = false;

    let activeFilterColors = document.querySelectorAll('.product-filter .color-swatch--active');
    for(let i = 0; i < activeFilterColors.length; i++) activeFilterColors[i].classList.remove('color-swatch--active');

    applyFilters();
});

let openFilter = document.querySelector('.open-filter');
if(openFilter) openFilter.addEventListener('click', function(e) {
    e.preventDefault();
    this.closest('.collection-products').classList.toggle('collection-products--filter-active');
})
//////////////////////////////////// End Filters ////////////////////////////////////////


////////////////////////////////////// Sliders //////////////////////////////////////////

let sliderControls = document.querySelectorAll('.slider__control');
for(let i = 0; i < sliderControls.length; i++) sliderControls[i].addEventListener('click', function(e) {
    e.preventDefault();
    let slider = this.closest('.slider__wrapper').querySelector('.slider');
    
    let slideWidth = slider.offsetWidth;
    let currentScroll = slider.scrollLeft;
    let maxScroll = slider.scrollWidth - slider.clientWidth;
    
    let maxPage = Math.round(maxScroll / slideWidth);
    let currentPage = Math.round(currentScroll / slideWidth);
    
    if(this.classList.contains('slider__control--next')) {
        if(currentScroll < maxScroll) currentPage++;
    } else if(this.classList.contains('slider__control--prev')) {
        if(currentScroll > 0) currentPage--;
        else currentPage = 1;
    }
    
    slider.scrollLeft = currentPage * slideWidth;
});

function runSlider(slider, autoslide) {
    setInterval(function() {
        let slideWidth = slider.offsetWidth;
        let currentScroll = slider.scrollLeft;
        let maxScroll = slider.scrollWidth - slider.clientWidth;
    
        let maxPage = Math.round(maxScroll / slideWidth);
        let currentPage = Math.round(currentScroll / slideWidth);
    
        currentPage++;
    
        slider.scrollLeft = currentPage * slideWidth;
    
        if(currentPage >= maxPage) {
            setTimeout(function() {
                slider.classList.add('scrolling-back');
                setTimeout(() => slider.scrollLeft = 0, 50);
                setTimeout(() => slider.classList.remove('scrolling-back'), 50);
            }, 1000);
        }
    }, autoslide * 1000);
}

let sliders = document.querySelectorAll('.slider');
for(let i = 0; i < sliders.length; i++) {
    let slider = sliders[i];
    if(slider.hasAttribute('data-autoslide')) {
        let autoslide = Number(slider.getAttribute('data-autoslide'));
        if(isNaN(autoslide)) continue;
        
        runSlider(slider, autoslide);
    }
}

//////////////////////////////////// End Sliders ////////////////////////////////////////

let mobMenuAct = document.querySelector('.mobile-menu-activator');
if(mobMenuAct) mobMenuAct.addEventListener('click', function(e) {
    e.preventDefault();
    document.body.classList.toggle('mobile-menu-active');
});

let overlay = document.querySelector('.site-menu__overlay');
if(overlay) overlay.addEventListener('click', function(e) {
    e.preventDefault();
    document.body.classList.toggle('mobile-menu-active');
});

let closeMenu = document.querySelector('.site-menu__close');
if(closeMenu) closeMenu.addEventListener('click', function(e) {
    e.preventDefault();
    document.body.classList.toggle('mobile-menu-active');
});

let mobileArrows = document.querySelectorAll('.mobile-arrow');
for(let i = 0; i < mobileArrows.length; i++) mobileArrows[i].addEventListener('click', function(e) {
    e.preventDefault();
    let actives = this.closest('.menu').querySelectorAll('.menu-item--active');
    this.closest('.menu-item').classList.toggle('menu-item--active');
    for(let i = 0; i < actives.length; i++) {
        if(actives[i] != this) actives[i].classList.remove('menu-item--active');
    }
});

jQuery(document).ready(function($){
  $('.promo-bar').slick({
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        sldeToShow : 1,
        slideToScroll : 1,
        pauseOnHover:false,
        fade : true,
        dots: false,
        arrows: false
  });

  //added DS 3-5-2024
  $("#filter-date-d").prop("checked", true);  //filter-date-d (descending)
  applyFilters();
  //added DS 3-5-2024
  
  //variantSelectUpdate(document.getElementById('variant-select'));  //commented out- DS 3-5-2024
});

